// SparkX AI License Config — Epokart
// এই ফাইলটি সরাসরি .gitignore তে যোগ করুন, public repo তে commit করবেন না।

export const LICENSE_CONFIG = {
  apiUrl: 'https://guard-server.sparkx-ai.shop/api/v1/verify-license',
  renewalApiUrl: 'https://guard-server.sparkx-ai.shop/api/v1/request-renewal-payment',
  packageStatusApiUrl: 'https://guard-server.sparkx-ai.shop/api/v1/package-status',
  requestPackagePaymentApiUrl: 'https://guard-server.sparkx-ai.shop/api/v1/request-package-payment',
  packagesApiUrl: 'https://guard-server.sparkx-ai.shop/api/v1/packages',
  requestPackageUpgradeApiUrl: 'https://guard-server.sparkx-ai.shop/api/v1/request-package-upgrade',
  apiKey: 'lic_live_e6d805d200a3b35ffc63f229d2830896c68881b61cc7ada2',
  domain: 'epokart.com',
  supportWhatsApp: '01516585709',
};